var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (collection, displayNav, undefined) {
var articles = collection
var width = 403
var height = 269
buf.push("<div class=\"fcc-carousel partner2-shows-carousel\">");
if ( displayNav)
{
buf.push("<a class=\"mgr-arrow-left icon-chevron-left js-mgr-prev\"></a><a class=\"mgr-arrow-right icon-chevron-right js-mgr-next\"></a>");
}
buf.push("<div class=\"mgr-cells js-mgr-cells\">");
// iterate articles.models
;(function(){
  var $$obj = articles.models;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var article = $$obj[$index];

var imgUrl = article.cropUrlFor('thumbnail_image', { width: width, height: height })
buf.push("<div class=\"mgr-cell js-mgr-cell\"><a" + (jade.attr("href", article.href(), true, true)) + "><img" + (jade.attr("src", imgUrl, true, true)) + (jade.attr("alt", article.get('thumbnail_title'), true, true)) + " class=\"fcc-carousel-image\"></a><a" + (jade.attr("href", article.href(), true, true)) + " class=\"fcc-carousel-caption-title\">" + (jade.escape(null == (jade_interp = article.get('thumbnail_title')) ? "" : jade_interp)) + "</a><div class=\"fcc-carousel-caption-subtitle\">" + (jade.escape(null == (jade_interp = article.get('author') ? article.get('author').name : '') ? "" : jade_interp)) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var article = $$obj[$index];

var imgUrl = article.cropUrlFor('thumbnail_image', { width: width, height: height })
buf.push("<div class=\"mgr-cell js-mgr-cell\"><a" + (jade.attr("href", article.href(), true, true)) + "><img" + (jade.attr("src", imgUrl, true, true)) + (jade.attr("alt", article.get('thumbnail_title'), true, true)) + " class=\"fcc-carousel-image\"></a><a" + (jade.attr("href", article.href(), true, true)) + " class=\"fcc-carousel-caption-title\">" + (jade.escape(null == (jade_interp = article.get('thumbnail_title')) ? "" : jade_interp)) + "</a><div class=\"fcc-carousel-caption-subtitle\">" + (jade.escape(null == (jade_interp = article.get('author') ? article.get('author').name : '') ? "" : jade_interp)) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div></div>");}.call(this,"collection" in locals_for_with?locals_for_with.collection:typeof collection!=="undefined"?collection:undefined,"displayNav" in locals_for_with?locals_for_with.displayNav:typeof displayNav!=="undefined"?displayNav:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;